export enum EFiscalTaxRegime {
  SimpleNational = 1,
  SimpleNationalExcess = 2,
  Normal = 3,
  MicroEntrepreneur = 4,
}
